import React from 'react';
import Spinner from '@atlaskit/spinner';
import styles from './Loader.module.css';

const Loader = ({ withFullWidth, size = 'large', text }) => (
    <div className={styles.Container + (withFullWidth ? ` ${styles.FullWidth}` : '')}>
        <Spinner size={size} />
        {text && <div className={styles.Text}>{text}</div>}
    </div>
);

export default Loader;
